import React from 'react';
import classNames from 'classnames';
import Immutable, { List } from 'immutable';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import { Block, Paragraph } from '@uncinc/react-drupal-core';

import { Breadcrumbs, WysiwygField } from '../../../components';

const NodeBasicPage = ({ entity, className }) => {
  const classes = classNames(className, 'NodeBasicPage');
  const node = entity.toJS();
  const title = node.title[0].value;
  const body = node.body[0]?.processed;

  const contactFormBlockEntity = entity.getIn(['field_contact_form_block', 0, 'entity'], Immutable.Map());

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      <Container>
        <div className="row">
          <div className="col-12">
            <Breadcrumbs />
          </div>
        </div>

        <div className="row">
          <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
            <h1 itemProp="name">{title}</h1>
            {body ? (
              <WysiwygField
                className="body--large"
                property="schema:text"
                html={body}
              />
            ) : null}
            <div className="content-section">
              {entity.get('field_paragraphs') ? (
                <div className="NodeBasicPage__paragraphs">
                  {entity.get('field_paragraphs', List()).map((paragraph) => {
                    const id = paragraph.get('target_id');
                    const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);

                    return (
                      <Paragraph
                        key={`paragraph:${id}:${language}`}
                        id={id}
                        entity={paragraph.get('entity')}
                      />
                    );
                  })}
                </div>
              ) : null}
            </div>
          </div>
        </div>

        {contactFormBlockEntity && (
          <Block entity={contactFormBlockEntity} />
        )}
      </Container>
    </article>
  );
};

export default NodeBasicPage;
